/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import {
  Row,
  Col,
  Space,
  Spin,
} from '@lib/index';

const MicrosoftEntraLogin = () => (
  <Row align="middle" justify="center" className="h-screen">
    <Col xs={12} sm={12} md={12} lg={12} xl={12} className="flex justify-center">
      <Space align="center">
        <Spin size="large" tip="logging" />
      </Space>
    </Col>
  </Row>
);

export default MicrosoftEntraLogin;
